// Storyblok keeps editorial content under a top-level `stories/` folder, so its
// markdown editor and multilink fields auto-populate internal links with a
// `stories/` (or `/stories/`) prefix. That folder is a CMS artifact and must
// NEVER appear on the public site (it only 301-redirects to the real folder
// URL, which is a wasted hop and an indexable leak). Strip a leading `stories/`
// segment, leaving a normal absolute path.
//
// Anchored at the start on purpose: it must not corrupt an external URL that
// merely contains `/stories/` further along (e.g. https://example.com/stories/x).
export const stripStoriesPrefix = (href: string): string => {
  if (!href) {
    return href
  }
  return href.replace(/^\/?stories\//, '/')
}
